import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import ProductsListPage from "./ProductsListPage";

const ImportProducts = () => {
  const { lang } = useI18n();
  const titles = {
    en: { title: "Import Products", sub: "Diversified imports across Food & Beverage, FMCG, Turkish Products, Medical, Industrial, and Consumer Goods." },
    tr: { title: "İthalat Ürünleri", sub: "Gıda, FMCG, Türk Ürünleri, Tıbbi, Endüstriyel ve Tüketici alanlarında çeşitli ithalat." },
    id: { title: "Produk Impor", sub: "Impor terdiversifikasi: Makanan & Minuman, FMCG, Produk Turki, Medis, Industri, dan Konsumen." },
  }[lang] || {};
  return <ProductsListPage type="import" eyebrow="Import" title={titles.title} subtitle={titles.sub} />;
};

export default ImportProducts;
